import api from './api';

export const requestLeave = (employeeId, data) => api.post(`/leaves/employees/${employeeId}/requests`, data);
export const myLeaves = () => api.get('/leaves/me');
export const pendingLeaves = () => api.get('/leaves/pending');
export const reviewQueueLeaves = () => api.get('/leaves/review-queue');
export const reviewLeave = (leaveId, actionOrPayload) => {
  const payload = typeof actionOrPayload === 'string' ? { action: actionOrPayload } : (actionOrPayload || {});
  return api.patch(`/leaves/${leaveId}/review`, payload);
};
export const observeLeave = (leaveId, observation) => api.patch(`/leaves/${leaveId}/observe`, { observation });
export const listByEmployee = (employeeId) => api.get(`/leaves/employees/${employeeId}`);
export const allLeaves = (params = {}) => api.get('/leaves', { params });
export const getLeaveById = (leaveId) => api.get(`/leaves/${leaveId}`);

export default { requestLeave, myLeaves, pendingLeaves, reviewQueueLeaves, reviewLeave, observeLeave, listByEmployee, allLeaves, getLeaveById };
